import script from "./TableData.vue?vue&type=script&lang=ts&setup=true"
export * from "./TableData.vue?vue&type=script&lang=ts&setup=true"

import "./TableData.vue?vue&type=style&index=0&id=2b764d30&lang=less"

const __exports__ = script;

export default __exports__